// vendor
import React from 'react'
import { Provider } from 'react-redux'
import configureStore from './store/configureStore'
import MainWrapper from 'components/main-wrapper'
import { getRoutes } from './routes'
import { HashRouter } from 'react-router-dom'

import { render } from 'react-dom'

// styles
require('./scss/app.scss')

const store = configureStore({})

export default function() {
  render(
    <Provider store={store}>
      <HashRouter>
        <MainWrapper>{getRoutes()}</MainWrapper>
      </HashRouter>
    </Provider>,
    document.getElementById('membership')
  )
}
